@if (switching()) {
  <app-loading-overlay [message]="'sidebar.switching_company' | translate" />
}

@if (ui.isMobile()) {
  <!-- Mobile overlay -->
  @if (open()) {
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <div class="sidebar-backdrop" (click)="close()"></div>
    <nav class="sidebar overlay">
      <div class="overlay-header">
        <img src="assets/images/shiftat-logo-small.svg" alt="Shiftat" class="overlay-logo" />
        <div class="overlay-header-spacer"></div>
        <button class="overlay-header-btn" (click)="close()">
          <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-cross-small"></mat-icon>
        </button>
      </div>

      <app-sidebar-company
        [company]="activeCompany()"
        [memberships]="memberships()"
        [collapsed]="false"
        (switchCompany)="switchCompany($event)"
      />

      <div class="sidebar-nav">
        @for (section of filteredSections(); track section.titleKey ?? $index) {
          <div class="sidebar-section">
            @if (section.titleKey) {
              <span class="sidebar-section-title">{{ section.titleKey | translate }}</span>
            }
            @for (item of section.items; track item.route) {
              <a [routerLink]="item.route" class="sidebar-item" [class.active]="item.active">
                <mat-icon [fontSet]="item.icon.fontSet" [fontIcon]="item.icon.fontIcon"></mat-icon>
                <span>{{ item.labelKey | translate }}</span>
              </a>
            }
          </div>
        }
      </div>

      <div class="sidebar-bottom">
        @for (item of filteredBottomItems(); track item.route) {
          <a [routerLink]="item.route" class="sidebar-item" [class.active]="item.active">
            <mat-icon [fontSet]="item.icon.fontSet" [fontIcon]="item.icon.fontIcon"></mat-icon>
            <span>{{ item.labelKey | translate }}</span>
          </a>
        }

        @if (isDev) {
          <a routerLink="/dev" routerLinkActive="active" class="sidebar-item">
            <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-bug"></mat-icon>
            <span>{{ 'sidebar.dev_toolkit' | translate }}</span>
          </a>
        }
      </div>

      <div class="overlay-profile">
        <button class="overlay-profile-btn" [matMenuTriggerFor]="profileMenu">
          <div class="overlay-profile-avatar">
            {{ userInitial() }}
          </div>
          <span class="overlay-profile-name">{{ userName() }}</span>
        </button>
      </div>

      <mat-menu #profileMenu="matMenu" yPosition="below">
        <button mat-menu-item (click)="switchLang('ar-SA')">
          <span>عربي</span>
          @if (currentLang() === 'ar-SA') {
            <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-check"></mat-icon>
          }
        </button>
        <button mat-menu-item (click)="switchLang('en-US')">
          <span>English</span>
          @if (currentLang() === 'en-US') {
            <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-check"></mat-icon>
          }
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="onLogout()">
          <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-sign-out-alt"></mat-icon>
          <span>{{ 'auth.logout' | translate }}</span>
        </button>
      </mat-menu>
    </nav>
  }
} @else {
  <!-- Desktop rail -->
  <nav class="sidebar" [class.expanded]="isExpanded()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-logo-wrapper">
      <div class="sidebar-logo">
        <img src="assets/images/shiftat-logo-large.svg" alt="Shiftat" class="logo-full" />
        <img src="assets/images/shiftat-logo-small.svg" alt="Shiftat" class="logo-icon" />
      </div>
    </div>

    <app-sidebar-company
      [company]="activeCompany()"
      [memberships]="memberships()"
      [collapsed]="!isExpanded()"
      (switchCompany)="switchCompany($event)"
    />

    <div class="sidebar-nav">
      @for (section of filteredSections(); track section.titleKey ?? $index) {
        <div class="sidebar-section">
          @if (section.titleKey) {
            <span class="sidebar-section-title sidebar-label">{{ section.titleKey | translate }}</span>
          }
          @for (item of section.items; track item.route) {
            <a [routerLink]="item.route" class="sidebar-item" [class.active]="item.active">
              <mat-icon [fontSet]="item.icon.fontSet" [fontIcon]="item.icon.fontIcon"></mat-icon>
              <span class="sidebar-label">{{ item.labelKey | translate }}</span>
            </a>
          }
        </div>
      }
    </div>

    <div class="sidebar-bottom">
      @for (item of filteredBottomItems(); track item.route) {
        <a [routerLink]="item.route" class="sidebar-item" [class.active]="item.active">
          <mat-icon [fontSet]="item.icon.fontSet" [fontIcon]="item.icon.fontIcon"></mat-icon>
          <span class="sidebar-label">{{ item.labelKey | translate }}</span>
        </a>
      }

      <button class="sidebar-item" (click)="toggleTheme()">
        <mat-icon [fontSet]="themeIcon().fontSet" [fontIcon]="themeIcon().fontIcon"></mat-icon>
        <span class="sidebar-label">{{ themeLabelKey() | translate }}</span>
      </button>

      @if (isDev) {
        <a routerLink="/dev" routerLinkActive="active" class="sidebar-item">
          <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-bug"></mat-icon>
          <span class="sidebar-label">{{ 'sidebar.dev_toolkit' | translate }}</span>
        </a>
      }
    </div>

    <div class="sidebar-profile">
      <button class="profile-btn" [matMenuTriggerFor]="desktopProfileMenu">
        <div class="profile-avatar">
          {{ userInitial() }}
        </div>
        <span class="sidebar-label">{{ userName() }}</span>
      </button>

      <mat-menu #desktopProfileMenu="matMenu" yPosition="above">
        <button mat-menu-item (click)="switchLang('ar-SA')">
          <span>عربي</span>
          @if (currentLang() === 'ar-SA') {
            <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-check"></mat-icon>
          }
        </button>
        <button mat-menu-item (click)="switchLang('en-US')">
          <span>English</span>
          @if (currentLang() === 'en-US') {
            <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-check"></mat-icon>
          }
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="onLogout()">
          <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-sign-out-alt"></mat-icon>
          <span>{{ 'auth.logout' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </nav>
}
